import './view-event-form.scss';
import ViewEventForm from './ViewEventForm';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BookedStatusEnum, Event } from '../../../../store/events/eventTypes';
import { ModalComponentEnum } from '../../../../store/modal/modalTypes';
import { useCancelBookEvent } from '../../../../store/events/eventHooks';
import {
  useCloseOldModal,
  useOpenOldModal,
} from '../../../../store/modal/modalHooks';

type PropsTypes = {
  event: Event;
  onSwitchShowPolicy: () => void;
  showPolicy: boolean;
};

const ViewEventFormContainer = ({
  event,
  onSwitchShowPolicy,
  showPolicy,
}: PropsTypes) => {
  const location = useLocation();
  const { t } = useTranslation();
  const openModal = useOpenOldModal();
  const closeModal = useCloseOldModal();
  const cancelEvent = useCancelBookEvent();

  const onCancelEvent = () => {
    if (event.bookedStatus === BookedStatusEnum.IN_WAIT_LIST) {
      openModal(ModalComponentEnum.QUESTION_CANCEL_WAITING_LIST_MODAL, {
        data: { event },
        callBack: () => {
          cancelEvent(event.id, location.pathname).finally(() => {
            closeModal();
          });
        },
      });
    } else {
      openModal(ModalComponentEnum.QUESTION_CANCEL_BOOK_EVENT_MODAL, {
        data: { event },
        callBack: () => {
          cancelEvent(event.id, location.pathname).finally(() => {
            closeModal();
          });
        },
      });
    }
  };

  return (
    <ViewEventForm
      title={t('EVENT_DETAILS_TITLE')}
      event={event}
      onSwitchShowPolicy={onSwitchShowPolicy}
      onCancelEvent={onCancelEvent}
      showPolicy={showPolicy}
      closeModal={closeModal}
    />
  );
};

export default ViewEventFormContainer;
